import type { IOvieHealthWeekdayDatum } from './analytics-common';

export interface IOvieHealthOverviewMetrics {
  totalCalls: number;
  appointmentsBooked: number;
  totalBookingsManaged: number;
  minutesAnswered: number;
  afterHoursCalls: number;
  repeatCallers: number;
  weekdayPattern: IOvieHealthWeekdayDatum[];
}
